exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-company-detail-draggable{width:100%;background:#FFFFFF;border:1px solid #EBEDF1;box-shadow:0 1px 2px rgba(38,110,255,0.05);border-radius:3px;margin-bottom:24px}.ps-company-detail-draggable__inner-container h3{font-size:18px;font-weight:600;margin:0}\n", ""]);

// exports
